module.exports = __webpack_public_path__ + "static/img/o3.c8fe617.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/o3.jpg
// module id = 7j+c
// module chunks = 0